<script setup lang="ts">
const { locale } = useI18n();
</script>
<template>
  <div class="relative">
    <MHeader is-404 />
    <main>
      <section class="h-[calc(100vh-216px)] flex flex-col justify-center items-center gap-4">
        <h1 class="text-8xl font-extralight -sm:text-4xl">404</h1>
        <p class="text-sm">Page not found</p>
        <NuxtLink :to="locale === 'en' ? '/' : '/de/'">
          <Button label="Back to home" severity="secondary" class="mt-4" />
        </NuxtLink>
      </section>
    </main>
    <MFooter />
  </div>
</template>
